import { Injectable } from '@angular/core';
import { AppConfigService } from '../../app.config';
import { AppConfig } from '../models/appConfig';

@Injectable({ providedIn: 'root' })
export class LoggerService {
    config: AppConfig;

    constructor(private appConfig: AppConfigService) {
        this.config = appConfig.getConfig();
    }

    public log(message?: any, ...optionalParams: any[]): void {
        if (this.config.logToConsole) {
            console.log(message, optionalParams);
        }
    }
}
